import { render, staticRenderFns } from "./FranceArticle.vue?vue&type=template&id=0a4c9682&"
import script from "./FranceArticle.vue?vue&type=script&lang=js&"
export * from "./FranceArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports